export const Certificates = {
  en: {
    'Create Certificate': 'Create Certificate',
    Code: 'Code',
    Services: 'Services',
    Comment: 'Comment',
    Used: 'Used',
    Created: 'Created',
    'out of': 'out of',
    Receipt: 'Receipt',
    'Certificate receipt': 'Certificate receipt',
    Search: 'Search',
  },
  uk: {
    'Create Certificate': 'Створити Сертифікат',
    Code: 'Код',
    Services: 'Сервіси',
    Comment: 'Коментар',
    Used: 'Використаний',
    Created: 'Створений',
    'out of': 'із',
    Receipt: 'Квитанція',
    'Certificate receipt': 'Квитанція сертифікату',
    Search: 'Пошук',
  },
};

export const CertificateForm = {
  en: {
    ...Certificates.en,
    'New Certificate': 'New Certificate',
    Comment: 'Comment',
    Total: 'Total',
    'Payment Types': 'Payment Types',
    'Choose services for the certificate':
      'Choose services for the certificate',
  },
  uk: {
    ...Certificates.uk,
    'New Certificate': 'Новий Сертифікат',
    Comment: 'Коментар',
    Total: 'Разом',
    'Payment Types': 'Типи Платежу',
    'Choose services for the certificate': 'Виберіть сервіси для сертифікату',
  },
};
